export enum NotificationType {
  Error = 'error',
  Success = 'success'
}
